import React from 'react';
import { Layout, Menu, Button, Typography } from 'antd';
import { ShopOutlined, LogoutOutlined, AuditOutlined } from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const SuperLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { key: '/super/companies', icon: <ShopOutlined />, label: '公司管理' },
    { key: '/super/inspection-admins', icon: <AuditOutlined />, label: '国检账号' },
  ];

  const selectedKey = location.pathname.startsWith('/super/inspection') ? '/super/inspection-admins'
    : '/super/companies';

  const handleLogout = () => {
    localStorage.removeItem('super_token');
    navigate('/super/login');
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider theme="dark" width={200}>
        <div style={{ height: 64, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Title level={4} style={{ color: '#fff', margin: 0 }}>超管后台</Title>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>
      <Layout>
        <Header style={{ background: '#fff', padding: '0 24px', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Button icon={<LogoutOutlined />} onClick={handleLogout}>退出登录</Button>
        </Header>
        <Content style={{ margin: 24 }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default SuperLayout;
